import axios from 'axios';
import {
  SurveyAccessData,
  SurveyResponse,
  SurveyResponseItem
} from '../types/survey';

const API_URL = process.env.REACT_APP_API_URL || (window.location.protocol === 'https:' ? '/api' : `http://${window.location.hostname}:3010/api`);

/**
 * Public survey API client - no auth interceptor needed.
 * Used by respondents accessing surveys via token URLs.
 */
class SurveyPublicApi {
  private client = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' }
  });

  async getSurveyByToken(token: string): Promise<SurveyAccessData> {
    const response = await this.client.get(`/survey-access/${token}`);
    return response.data;
  }

  async saveResponses(token: string, responses: SurveyResponseItem[]): Promise<SurveyResponse> {
    const response = await this.client.post(`/survey-access/${token}/respond`, { responses });
    return response.data;
  }

  async submitResponses(token: string, responses: SurveyResponseItem[]): Promise<SurveyResponse> {
    const response = await this.client.put(`/survey-access/${token}/submit`, { responses });
    return response.data;
  }

  async getAiAssist(token: string, data: {
    question: string;
    category?: string;
    currentAnswer?: string;
    defaultAnswer?: string;
  }): Promise<{ suggestions: Array<{ type: string; title: string; content: string }> }> {
    const response = await this.client.post(`/survey-access/${token}/ai-assist`, data);
    return response.data;
  }
}

export const surveyPublicApi = new SurveyPublicApi();
export default surveyPublicApi;
